<template>
	<div id="_setting">

		<h1>SETTING</h1>
		
		<div>
			<div class="menuTab">GENERAL</div>
			<div class="menuTab">USERS</div>
			<div class="menuTab">GROUP</div>
			<div class="menuTab">LOCATIONS</div>
			<div class="menuTab">CATEGORIES</div>
			<div class="menuTab">TAGS</div>
			<div class="menuTab">BACKUP</div>
			<div class="menuTab" @click="checkformat">CHECK FORMAT</div>
		</div>
		
		<br>
		<div class="general settingContent">
		
			GENERAL SETTING ::<br><br>
			
			SHOW PAGES <input type="checkbox" name="showPage"><br>
			ITEMS PER PAGE <input type="number" name="perPage" width="3"><br>
			MAXIMUM LOGIN TRIES <input type="number" name"loginTries" width="3"><br>
					
		</div>
		
		<br>
		<div class="user settingContent">
		
			USER SETTING ::<br><br>
			
			ADD USER<br>
			REMVOE USER<br>
			EDIT USER<br>
			
					
		</div>
		
		
		<br>
		<div class="group settingContent">
		
			GROUP SETTING ::<br><br>
			
			ADD GROUP<br>
			REMVOE GROUP<br>
			EDIT GROUP<br>
			
					
		</div>
		
		<br>
		<div class="location settingContent">
		
			LOCATION SETTING ::<br><br>
			
			ADD LOCATION<br>
			REMVOE LOCATION<br>
			EDIT LOCATION<br>
			
			//locations....
			<hr>
			<div v-for="location in locations">
				<table class="locationTable" style="width:600px;">
					<tr><td class="field">Name		</td><td>{{location.name}}</td></tr>
					<tr><td class="field">Base Path	</td><td>{{location.base}}</td></tr>
					<tr><td class="field">API			</td><td>{{location.api}}</td></tr>
					<tr><td class="field">INFO		</td><td>{{location.info}}</td></tr>
					<tr><td class="field">AUTH		</td><td>{{location.auth}}</td></tr>
					<tr><td class="field">Create Share</td><td>{{location.createShare}}</td></tr>
					<tr><td class="field">Delete Share</td><td>{{location.deleteShare}}</td></tr>
					<tr><td class="field">Logout		</td><td>{{location.logout}}</td></tr>
				</table>
				
				<br>
				<input type="checkbox">ALLOW SEARCH 	<br>
				<input type="checkbox">ALLOW DOWNLOAD	<br>
				
				<hr>
			</div>
					
		</div>
		
		
		<br>
		<div class="categories settingContent">
		
			CATEGORIES SETTING ::<br><br>
			
			ADD CATEGORY<br>
			REMVOE CATEGORY<br>
					
		</div>
		
		<br>
		<div class="tags settingContent">
		
			TAGS SETTING ::<br><br>
			
			ADD TAGS<br>
			REMVOE TAGS<br>
					
		</div>
		
		<br>
		<div class="backup settingContent">
		
			BACKUP SETTING ::<br><br>
			
			Backup Now<br>
			Backup Schedule<br>
			Restotre Backup<br>
					
		</div>
		
		
	</div>
</template>

<script>

export default {
  name: 'SETTING',
  data () {
    return {
		locations: [{name: "PENDING",base: "/ftp.tv.pending",api: "https://192.168.40.31:5001/webapi",info: "info query",auth: "auth",createShare: "test",deleteShare: "delete",logout: "logout"},
					{name: "PENDING2",base: "/ftp.tv.pending",api: "https://192.168.40.31:5001/webapi",info: "info query",auth: "auth",createShare: "test",deleteShare: "delete",logout: "logout"}]
    }
  },
  methods: {
	checkformat(){
		this.axios.post(this.$bus.mamServer+"/checkformat",{key: "secretcode2018"}).then((result)=>{

			var data = result.data
			console.log(result)
			if (data.status==="success"){
			}
		}).catch((err)=>{
			console.log(err)
		})
	}
  },
  created: function (){
	//get locations
	this.axios.post(this.$bus.mamServer+"/getLocationInfos").then((result)=>{
		this.locationInfos = result.data
	}).catch((err)=>{
		console.log(err)
	})
	
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#_setting{
	background-color:lightgray;
	width:100%;
	height:100%;
}

.menuTab{
	background-color:gray;
	width:110px;
	display:inline;
	border-radius:5px;
	height:25px;
	text-align:middle;
	vertical-valign:middle;
	padding-top:5px;
	cursor:pointer;
}
.menuTab:hover{
	background-color:lightgreen;
}

.settingContent{
	text-align:left;
	margin-left:8px;
	margin-bottom:5px;
}

.locationTable td{
	border: 1px solid black;
	padding: 2px;
	border-radius:3px;
}

.field{
	background-color: lightblue;
	font-size:16px;
}

</style>





// WEBPACK FOOTER //
// src/components/Setting.vue